import React from "react"
import TailwindProvider from "../providers/TailwindProvider"
import { getThemeStylesheet } from "../../packs/travel_book/avia_v3/utils/filters/build"
import Maintenance from "./Maintenance"

const RootLayout = ({ children, themeName }) => {
  const theme = getThemeStylesheet(themeName)

  return (
    <TailwindProvider>
      <div data-theme={theme} className="w-full mx-auto">
        {children}
      </div>
    </TailwindProvider>
  )
}

export default RootLayout
